let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jdltr")).then(() => parcelRequire('651Nn'));